import React from "react";
import { Drawer, Menu, ConfigProvider, theme } from "antd";
import { LogoutOutlined, CloseCircleOutlined } from "@ant-design/icons";
import styles from "./MobileSidebar.module.css"
import logo from "../../../assets/logo.png"
import logoutPng from "../../../assets/log.png"

const MobileSidebar = ({
    isVisible,
    onClose,
    menuItems,
    activeElement,
    handleClick,
    openModal
}) => {

    const handleMenuClick = (key) => {
        handleClick(key);
        onClose();
    };

    const handleOpenModal = () => {
        openModal()
        onClose()
    }

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorBgBase: "#b17e32",
                    colorBgLayout: "#1e1e1e",
                    colorText: "#ffffff",
                    colorTextSecondary: "#b3b3b3",
                    colorBorder: "#b17e32",
                    colorPrimary: "#cf9f41",
                    colorPrimaryHover: "#40a9ff",
                    colorBgContainer: "#2a2a2a",
                    colorBgElevated: "#3a3a3a",
                },
            }}
        >
            <Drawer
                title={
                    <img
                        src={logo}
                        alt="Logo"
                        className={styles.headingLogo}
                    />
                }
                placement="left"
                closable
                onClose={onClose}
                open={isVisible}
                width={250}
                className={styles.mobileSidebarDrawer}
                closeIcon={<CloseCircleOutlined style={{ color: "#b17e32" }} />}
            >
                <div className={styles.sidebarContent}>
                    <div
                        className={styles.elementWrapper}
                    >
                        {menuItems.map((item) => (
                            <div
                                key={item.key}
                                onClick={() => handleMenuClick(item.key)}
                                className={activeElement === item.key ? styles.sidebarelementactive : styles.sidebarelement}
                            >
                                <img
                                    src={activeElement === item.key ? item.activeIcon : item.icon}
                                    alt={item.label}
                                />
                                <p> {item.label} </p>
                            </div>
                        ))}
                    </div>

                    <div
                        className={styles.logoutWrapper}
                        onClick={handleOpenModal}
                    >
                        <img
                            src={logoutPng}
                            alt="Logout"
                            className={styles.logout}
                        />
                        <p>
                            Logout
                        </p>
                    </div>
                </div>
            </Drawer>
        </ConfigProvider>
    );
};

export default MobileSidebar;
